var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .st0 {\n      stroke: #FF647D;\n      fill: none;\n      stroke-linecap: round;\n      stroke-linejoin: round;\n      stroke-width: 3px;\n      stroke-dasharray: 475 25;\n      stroke-dashoffset: 1000;\n    }\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    pathLength: 1000,
    strokeDasharray: 0,
    d: "M240.2,126.2c0,63.9-51.8,115.8-115.8,115.8c-7.3,0-14.4-0.7-21.2-2L151,132.8c0.7-1.7,0.1-3.2-1.5-3.2H94         c-1.7,0-3.6,1.5-4.3,3.2l-6,13.6c-0.7,1.7-0.3,3.2,1.4,3.2h36.7l-38,85C39.9,218.2,8.7,175.9,8.7,126.2         c0-63.9,51.8-115.8,115.8-115.8c6.4,0,12.7,0.5,18.8,1.5L95.9,118.1c-0.7,1.7-0.1,3.2,1.5,3.2H153c1.7,0,3.6-1.5,4.3-3.2l6-13.6         c0.7-1.7,0.3-3.2-1.4-3.2h-36.7L162.8,17C207.9,32.8,240.2,75.7,240.2,126.2z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "4s",
    values: "1000;0",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.65df18253e11ea4b3d63045b1bddbb56.svg";
export { ForwardRef as ReactComponent };